export const loadBootstrap = () => {
  if (document.getElementById("admin-bootstrap")) return;

  const link = document.createElement("link");
  link.id = "admin-bootstrap";
  link.rel = "stylesheet";
  link.href =
    "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css";
  link.integrity =
    "sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC";
  link.crossOrigin = "anonymous";

  document.head.appendChild(link);
};

export const unloadBootstrap = () => {
  const link = document.getElementById("admin-bootstrap");
  if (link) document.head.removeChild(link);
};
